var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountPablo = function SvgAccountPablo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2,
    d: "m10.404 8.302-.003.002a.08.08 0 0 0 .018.142l-.032.094zm0 0A4.357 4.357 0 0 0 7.938.346 4.357 4.357 0 0 0 5.47 8.301a.083.083 0 0 1-.023.145l.033.094-.033-.094a7.61 7.61 0 0 0-5.092 6.568.497.497 0 0 0 .502.532c.286 0 .51-.23.527-.508a6.56 6.56 0 0 1 6.549-6.147 6.56 6.56 0 0 1 6.549 6.147.536.536 0 0 0 .527.508.497.497 0 0 0 .502-.53 7.54 7.54 0 0 0-2.202-4.761zM4.609 4.719a3.327 3.327 0 0 1 5.673-2.359 3.32 3.32 0 0 1-2.348 5.673A3.323 3.323 0 0 1 4.609 4.72Z"
  })));
};
export default SvgAccountPablo;